import { render } from "./FriendsNpc2.vue?vue&type=template&id=2ad5bc7f&scoped=true"
import script from "./FriendsNpc2.vue?vue&type=script&lang=js"
export * from "./FriendsNpc2.vue?vue&type=script&lang=js"

import "./FriendsNpc2.vue?vue&type=style&index=0&id=2ad5bc7f&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad5bc7f"]])

export default __exports__